import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiResponse, ApiService } from './api.service';
import { ContentService } from './content.service';
import { StaticContent } from '@models/static-content.model';

interface ConfigResponse {
  static_content: StaticContent[];
  min_app_version: string | null;
  settings: any;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  settings: any;

  constructor(
    private apiService: ApiService,
    private contentService: ContentService
  ) { }

  platformConfig(): Observable<ApiResponse<ConfigResponse>> {
    return this.apiService.get<ApiResponse<ConfigResponse>>(`public/platforms/${this.apiService.getPlatformToken}/config`).pipe(tap({
      next: (config: ApiResponse<ConfigResponse>) => {
        this.settings = config.data.settings;
        this.contentService.setContent(config.data.static_content);
      }
    }));
  }
}
